import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Check, Delete } from 'lucide-react-native'
import { colors } from '@chillout/core'
import { NumpadKey } from './NumpadKey'

interface NumpadProps {
  onDigit: (digit: string) => void
  onDelete: () => void
  onConfirm?: () => void
  canConfirm?: boolean
  isLoading?: boolean
  doubleZero?: boolean
  onDoubleZero?: () => void
}

const ROWS = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
]

export function Numpad({ onDigit, onDelete, onConfirm, canConfirm = false, isLoading = false, doubleZero = false, onDoubleZero }: NumpadProps) {
  const { t } = useTranslation()
  const rowClassName = `flex-row gap-2`

  return (
    <View className="gap-2">
      {ROWS.map((row) => (
        <View key={row.join('')} className={rowClassName}>
          {row.map((digit) => (
            <NumpadKey
              key={digit}
              digit={digit}
              onPress={() => onDigit(digit)}
              disabled={isLoading}
              accessibilityLabel={digit}
            />
          ))}
        </View>
      ))}
      <View className={rowClassName}>
        {doubleZero ? (
          <>
            <NumpadKey
              Icon={Delete}
              onPress={onDelete}
              disabled={isLoading}
              accessibilityLabel={t('numpad.deleteButton')}
            />
            <NumpadKey
              digit="0"
              onPress={() => onDigit('0')}
              disabled={isLoading}
              accessibilityLabel="0"
            />
            <NumpadKey
              digit="00"
              onPress={() => onDoubleZero?.()}
              disabled={isLoading}
              accessibilityLabel={t('numpad.doubleZeroButton')}
            />
          </>
        ) : (
          <>
            <NumpadKey
              Icon={Delete}
              onPress={onDelete}
              disabled={isLoading}
              accessibilityLabel={t('numpad.deleteButton')}
            />
            <NumpadKey
              digit="0"
              onPress={() => onDigit('0')}
              disabled={isLoading}
              accessibilityLabel="0"
            />
            {onConfirm ? (
              <NumpadKey
                Icon={Check}
                iconColor={colors.accent.DEFAULT}
                onPress={onConfirm}
                disabled={!canConfirm || isLoading}
                loading={isLoading && canConfirm}
                accessibilityLabel={t('numpad.confirmButton')}
              />
            ) : (
              <View className="flex-1" />
            )}
          </>
        )}
      </View>
    </View>
  )
}
